import { SelectOrTextComponent } from './select-or-text.component';

export default angular
  .module('sfMobile.components.select-or-text', [
    'sfMobile.components.input-select',
  ])
  .component('sfSelectOrText', SelectOrTextComponent).name;
